export default "__VITE_ASSET__DhBCi13I__"